import { render, staticRenderFns } from "./EModalBoletimFranquia.vue?vue&type=template&id=4b1156c0&scoped=true"
import script from "./EModalBoletimFranquia.vue?vue&type=script&lang=js"
export * from "./EModalBoletimFranquia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1156c0",
  null
  
)

export default component.exports